import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: function () {
    //     return import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    //   }
    // },

    // {
    //     path: '/',
    //     name: 'categories',
    //     component: function () {
    //         return import(/* webpackChunkName: "categories" */ '../views/CategoryView.vue');
    //     }
    // },
    {
        path: '/',
        name: 'catalogues',
        component: function () {
            return import(/* webpackChunkName: "categories" */ '../views/CategoryView.vue');
        }
    },{
        path: '/search',
        name: 'search',
        component: function () {
            return import('../views/SearchView.vue');
        }
    },
    //  {
    //     path: '/catalogue/:catalogue',
    //     name: 'catalogue',
    //     component: function () {
    //         return import(/* webpackChunkName: "categories" */ '../views/CatalogueView.vue');
    //     },
    //     props: true
    // },
    // {
    //     path: '/category/:slug_category/catalogue/:slug_catalogue',
    //     name: 'catalogue',
    //     component: function () {
    //         return import(/* webpackChunkName: "categories" */ '../views/CatalogueView.vue');
    //     },
    //     props: true
    // },

    // AUTH
    {
        path: '/login',
        name: 'login',
        component: function () {
            return import(/* webpackChunkName: "categories" */ '../views/LoginView.vue');
        },
        props: true
    }
];

const router = new VueRouter({
    routes
});


router.beforeEach(function (to, from, next) {
    $eventbus.$emit('menu:hide');
    next();
})


export default router;
